export default "__VITE_ASSET__B7JGf42P__"